/**
 * Toast Type Definitions
 * @module shared/types/toast.types
 *
 * Type definitions for Toast components.
 * Expanded to match Alert component variants for consistency.
 */

/**
 * Toast variant options
 * Matches Alert variants for consistent user feedback across components
 */
export enum ToastVariant {
  Default = 'default',
  Destructive = 'destructive',
  Warning = 'warning',
  Success = 'success',
  Info = 'info',
}
